import { graphql, useStaticQuery } from "gatsby"

export type GenericPageUrlQueryResult = {
  flatData: {
    url: string
    metaTitle: string
  }
}

type Query = {
  GraphCmsSquidex: {
    queryGenericPageContents: GenericPageUrlQueryResult[]
  }
}

export default function useGenericPageUrlQuery(): GenericPageUrlQueryResult[] {
  const { GraphCmsSquidex } = useStaticQuery<Query>(graphql`
    {
      GraphCmsSquidex {
        queryGenericPageContents(
          top: 1000
          filter: "data/noIndex/iv ne true"
          orderby: "data/url/iv asc"
        ) {
          flatData {
            url
            metaTitle
          }
        }
      }
    }
  `)

  return GraphCmsSquidex.queryGenericPageContents
}
